import { Component, Inject, Injector, Input, OnDestroy, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
import { TagTextData } from '../tag-text/tag-text.component';
import { Module, TextPosition } from 'projects/common/model/ModuleModel';
import { Device } from '../../model/Device';
import { AbstractComponent } from '../abstract.component';
import { isPlatformBrowser } from '@angular/common';
import { FaqsService } from 'projects/common/services/faqs.service';

export interface FrequentlyAskedQuestionData {
  title?: TagTextData;
  items: FrequentlyAskedQuestionItemData[];
  text_position?: TextPosition;
  text_color?: string;
}

export interface FrequentlyAskedQuestionItemData {
  question: string;
  answer: string;
  id?: string;
}

@Component({
  selector: 'frequently-asked-question',
  template: `
    <tag-text *ngIf="module.title" class="title-content" [data]="module.title"></tag-text>
    <div class="frequently-asked-question-container {{module.data.text_position}}">
      <tag-text *ngIf="module.data.title" class="frequently-asked-title {{module.data.text_position}}" [data]="module.data.title"></tag-text>
      <div class="-eva-3-fwidth" [ngStyle]="{'color': module.data.text_color}">
        <ul class="eva-3-dropdown" *ngFor="let item of module.data.items; let i = index; let lastItem = last">
          <li *ngIf="isNotEmpty(item)" class="dropdown-item -active" [ngClass]="{'last-element': lastItem}" [attr.id]="item.id || null">
            <span class="dropdown-item-container" (click)="toggleAnswer(i)">
              <h5 class="item-label" [ngClass]="device.type === 'MOBILE' ? 'eva-3-h6' : 'eva-3-h5'" [innerHTML]="item.question"></h5>
              <i class="dropdown-icon" [ngClass]="{'eva-3-icon-chevron-up': isNotVisible(i), 'eva-3-icon-chevron-down': isVisible(i)}"></i>
            </span>
            <ul class="dropdown-subcontent" [ngClass]="{'drowpdown-hidden': isNotVisible(i)}">
              <li class="dropdown-subitem ">
                <span class="dropdown-item-container">
                  <label class="eva-3-body-2" [innerHTML]="item.answer"></label>
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  `,
  styleUrls: ['./frequently-asked-question.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FrequentlyAskedQuestionComponent extends AbstractComponent implements OnInit, OnDestroy {
  @Input() override module: Module<FrequentlyAskedQuestionData>;
  @Input() device: Device;

  private visibilityByIndex: boolean[];
  private callbacks: string[] = [];

  constructor(injector: Injector, @Inject(PLATFORM_ID) private platformId: string, private faqsService: FaqsService) {
    super(injector);
  }

  ngOnInit(): void {
    this.visibilityByIndex = new Array(this.module.data.items.length).fill(false);
    const showModule = this.module?.data?.items?.some(item => this.isNotEmpty(item));
    if (!showModule && this.module.unique_id && isPlatformBrowser(this.platformId)) {
      document.getElementById(this.module.unique_id)?.classList?.add("-hidden");
    }
    this.registerFaqToggleHandlers();
  }

  ngOnDestroy(): void {
    this.callbacks.forEach(faqId => this.faqsService.unregisterFaqCallbacks(faqId));
  }

  toggleAnswer(index: number) {
    this.visibilityByIndex[index] = !this.visibilityByIndex[index];
  }

  isVisible(index: number): boolean {
    return this.visibilityByIndex[index];
  }

  isNotVisible(index: number): boolean {
    return !this.isVisible(index);
  }

  isNotEmpty = (item: FrequentlyAskedQuestionItemData) : boolean => {
    return Boolean(item.question && item.answer);
  }

  getModuleId() {
    return this.module?.id;
  }

  private registerFaqToggleHandlers(): void {
    this.module?.data?.items?.forEach((item, index) => {
      if (!item.id) return;

      this.callbacks.push(item.id);
      this.faqsService.registerFaqCallbacks(item.id, () => this.toggleAnswer(index), () => this.isVisible(index));
    });
  }
}
